import { type FC } from "react";
import { InformationPage } from "~/common/components/informationPage/InformationPage";
import { MAIL_SENT } from "~/utils/url/staticResources";

import { SAVED_CONFIGS_PAGE } from "~/utils/url/staticUrls";
import { Button } from "~/common/mui";
import { useTranslation } from "react-i18next";

interface Props {
  numberOfConfigurations: string;
  imageSrc?: string;
}

export const ShareLinearConfigurationsConfirmationPage: FC<Props> = ({ numberOfConfigurations, imageSrc = MAIL_SENT }) => {
  const { t } = useTranslation();

  return (
    <InformationPage.CenterContents className={"pb-30"}>
      <InformationPage.Title>
        {t("page.shareLinearConfigurationsConfirmation.title", { count: parseInt(numberOfConfigurations) })}
      </InformationPage.Title>
      <InformationPage.Image src={imageSrc} />
      <Button href={SAVED_CONFIGS_PAGE}>{t("linear.request.quote.success.btn.savedConfigs")}</Button>
    </InformationPage.CenterContents>
  );
};

export function createShareLinearConfigurationConfirmationPage(numberOfConfigurations: string) {
  return <ShareLinearConfigurationsConfirmationPage numberOfConfigurations={numberOfConfigurations} />;
}
